import React from 'react'

import { PlusIcon, DeleteIcon, CustomiseIcon, DownloadIcon, OpenIcon } from '../Icon'
import Text, { TextLink } from '../Type'

import Button from './Button'

export const AddButton = props => <Button variant="tertiary" icon={<PlusIcon />} {...props} />

export const RemoveButton = props => <Button variant="tertiary" icon={<DeleteIcon />} {...props} />

export const CustomiseButton = props => <Button variant="tertiary" icon={<CustomiseIcon />} {...props} />

export const ExportButton = props => <Button variant="tertiary" icon={<DownloadIcon />} {...props} />

export const ExternalLinkButton = ({ children, level = 'sm', as = 'span', ...props }) => (
  <Text as={as} lineHeight="1" level={level}>
    <TextLink target="_blank" {...props}>
      {children}
      <OpenIcon
        height={level === 'xs' ? 14 : 16}
        width={level === 'xs' ? 14 : 16}
        mt={level === 'xs' ? '-3px' : '-4px'}
        ml={level === 'xs' ? '4px' : '8px'}
        verticalAlign="middle"
      />
    </TextLink>
  </Text>
)

export { default as TextButton } from './TextButton'
export { default as SortButton } from './SortButton'
export { default as ToggleButton } from './Toggle'
export { default as GuideButton } from './Guide'

export default Button
